export class RoomFeatureLayout {
	public fields = [{ fieldName: 'roomFeatureType', label: 'Type' }];
}
